module.exports = __webpack_public_path__ + "static/media/chat-gray.a79360a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dealroom-icons/chat-gray.svg
// module id = 1926
// module chunks = 0